import * as React from 'react';
import { Chevron } from '../';
import './BackButton.scss';

interface BackButtonLinkProps {
  href: string;
}

interface BackButtonClickableProps {
  onClick();
}

type Props = BackButtonLinkProps | BackButtonClickableProps;

function isClickable(props: Props): props is BackButtonClickableProps {
  return (props as BackButtonClickableProps).onClick !== undefined;
}

export const BackButton = (props: Props) => {
  const chevron = <Chevron direction='left' />;

  if (!isClickable(props)) {
    return <a className='mb-3 delivery-back-button'>{chevron} Back</a>;
  } else {
    return (
      <div onClick={props.onClick} className='mb-3 delivery-back-button'>
        {chevron} Back
      </div>
    );
  }
};
